<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
    :create-route="createRoute"
  >
    <template #filter>
      <SchedulerFilter
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="scheduler"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @action:delete="onDeleteWithRefresh"
      @action:edit="onActionEdit"
      @change:sort="onChangeSort"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { TimesheetModel as Model } from './Model'
import { SchedulerStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import { SCHEDULER_ROUTES as ROUTES } from './utils'
import SchedulerFilter from './components/SchedulerFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'SchedulerList',
  components: {
    BLayoutList,
    BTableCommon,
    SchedulerFilter,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  methods: {
    onActionEdit(data) {
      this.$router.push({
        name: ROUTES.EDIT,
        params: {
          id: data.id,
        },
      })
    },
    onActionView(data) {
      this.$router.push({
        name: ROUTES.VIEW,
        params: {
          id: data.id,
        },
      })
    },
  },
}
</script>
